import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";

const ModalAgregarOrden = ({ show, handleClose, onReturnValue }) => {
  const [formData, setFormData] = useState({
    fechaInicio: "",
    fechaFin: "",
    descripcion: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleGenerate = async (e) => {
    e.preventDefault();

    const { fechaInicio, fechaFin, descripcion } = formData;

    // Validaciones requeridas
    if (!fechaInicio || !fechaFin) {
      Swal.fire({
        icon: "warning",
        title: "Campos requeridos",
        text: "Debes completar Fecha Inicio y Fecha Fin.",
      });
      return;
    }

    // Si descripción es vacía o solo espacios, usar "Sin Descripcion"
    const descFinal =
      (descripcion ?? "").trim().length === 0 ? "Sin Descripcion" : descripcion.trim();

    try {
      setIsSubmitting(true);
      await onReturnValue({
        ...formData,
        descripcion: descFinal,
      });
      // Opcional: cerrar el modal después de guardar
      // handleClose();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: "Ocurrió un problema al guardar la orden de pago.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Agregar Orden de Pago</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleGenerate} noValidate>
          <Form.Group className="mb-3">
            <Form.Label>Fecha Inicio</Form.Label>
            <Form.Control
              type="date"
              name="fechaInicio"
              value={formData.fechaInicio}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Fecha Fin</Form.Label>
            <Form.Control
              type="date"
              name="fechaFin"
              value={formData.fechaFin}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Descripción</Form.Label>
            <Form.Control
              as="textarea"
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              rows={3}
              placeholder="Ingrese una descripción"
            />
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button
              variant="danger"
              onClick={handleClose}
              className="me-2"
              disabled={isSubmitting}
            >
              Cancelar
            </Button>

            <Button variant="primary" type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Guardando..." : "Guardar"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAgregarOrden;
